import { render, staticRenderFns } from "./CoverPage.vue?vue&type=template&id=d43ef9bc"
import script from "./CoverPage.vue?vue&type=script&lang=js"
export * from "./CoverPage.vue?vue&type=script&lang=js"
import style0 from "./CoverPage.vue?vue&type=style&index=0&id=d43ef9bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports